/* FAAN — extra scheda prodotto (Cloude/Dario). Vale per DARIO e NEW STYLE.
   - "Paga anche in 3 rate da €X" sotto il prezzo (aggiornata al cambio variante)
   - prezzo sotto ogni pillola variante (match per data-variant-id, RE-INIETTATO ad ogni
     re-render del variant-picker: prima sparivano al click)
   - badge "Più scelto" (metafield faan.piu_scelto = titolo variante)
   - riga garanzie sotto il buy box
   - tag .faan-pdp-title sul titolo (per il sizing mobile via settings) */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var form = document.querySelector('product-form-component form, form[action*="/cart/add"]');
  if (!form) return;

  function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function debounce(fn, w) { var t; return function () { clearTimeout(t); t = setTimeout(fn, w); }; }

  // Titolo: primo h5 del blocco dettagli -> classe per il sizing mobile (settings)
  var det = document.querySelector('.product-details');
  var titleEl = det && det.querySelector('h5, h1, h2, .product-title');
  if (titleEl) titleEl.classList.add('faan-pdp-title');

  // Blocco badge (Ricco di Fibre / Super Croccanti / Irresistibili) -> classe per nasconderlo su mobile.
  // IMPORTANTE: deve essere il gruppo SOLO-badge, NON il wrapper dei dettagli (che contiene anche
  // titolo/prezzo/varianti/carrello) -> escludo i gruppi che contengono elementi d'acquisto,
  // altrimenti su mobile sparirebbe l'intero buy box.
  if (det) {
    var groups = [].slice.call(det.querySelectorAll('.group-block'));
    for (var gi = 0; gi < groups.length; gi++) {
      var g = groups[gi], gt = g.textContent || '';
      if (/Ricco di Fibre/.test(gt) && /Irresistibili/.test(gt) &&
          !g.querySelector('product-price, variant-picker, product-form-component, [class*="buy-buttons"], .price, .quantity-selector, .faan-rate, .faan-assurance')) {
        g.classList.add('faan-pdp-badges');
        break;
      }
    }
  }

  fetch(location.pathname.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      var byId = {};
      p.variants.forEach(function (v) { byId[String(v.id)] = v; });

      /* ---- "Paga in 3 rate" ---- */
      var rate = document.querySelector('.faan-rate');
      if (!rate) {
        rate = document.createElement('div');
        rate.className = 'faan-rate';
        /* 01/10: "Paga in 3 rate" SOTTO il blocco Aggiungi al carrello (prima stava sopra le varianti) */
        var buyBlocks = [].slice.call(document.querySelectorAll('.product-information .buy-buttons-block, .buy-buttons-block'));
        var buyAnchor = buyBlocks.filter(function (el) { return el.offsetParent !== null; })[0] || buyBlocks[0];
        var anchor = document.querySelector('.variant-picker');
        if (buyAnchor) {
          buyAnchor.insertAdjacentElement('afterend', rate);
          /* 14/10: riquadro Listino B2B (solo clienti B2B: il template esiste solo per loro) subito sotto il carrello, sopra «3 rate» */
          var b2bTpl = document.getElementById('faan-b2b-listino-box');
          if (b2bTpl && !document.querySelector('.faan-b2b-box')) {
            buyAnchor.insertAdjacentElement('afterend', b2bTpl.content.firstElementChild.cloneNode(true));
          }
        } else if (anchor) {
          anchor.insertAdjacentElement('beforebegin', rate);
        } else {
          var prices = [].slice.call(document.querySelectorAll('.product-information .price, product-price, .price'));
          var vis = prices.filter(function (el) { return el.offsetParent !== null; })[0] || prices[0];
          if (vis) vis.insertAdjacentElement('afterend', rate);
        }
      }
      function currentVariant() {
        var idInput = form.querySelector('[name="id"]');
        var vid = idInput ? idInput.value : null;
        if (!vid) { vid = new URLSearchParams(location.search).get('variant') || (p.variants[0] && p.variants[0].id); }
        return byId[String(vid)] || p.variants[0];
      }
      function renderRate() {
        var v = currentVariant();
        if (!v || !rate) return;
        rate.innerHTML =
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>' +
          '<span>Paga anche in <b>3 rate</b> da <span class="r-amt">' + euro(Math.round(v.price / 3)) + '</span> senza interessi</span>';
      }

      /* ---- Badge "Più scelto" ---- */
      var best = (window.__FAAN_BESTSELLER || '').toString().trim();
      function placeBadge() {
        if (!best) return;
        [].slice.call(document.querySelectorAll('.variant-option--buttons')).forEach(function (fs) {
          var match = null;
          [].slice.call(fs.querySelectorAll('.variant-option__button-label')).forEach(function (l) {
            var input = l.querySelector('input');
            var val = input ? (input.value || '').trim() : '';
            var txt = (l.textContent || '').trim();
            if (!match && (val === best || txt === best || txt.indexOf(best) > -1)) match = l;
          });
          var existing = fs.querySelector('.faan-best-badge');
          if (!match) { if (existing) existing.remove(); return; }
          var b = existing || document.createElement('span');
          if (!existing) { b.className = 'faan-best-badge'; b.textContent = '★ Più scelto'; fs.appendChild(b); }
          if (getComputedStyle(fs).position === 'static') fs.style.position = 'relative';
          fs.classList.add('faan-has-best');
          /* Posizione misurata con getBoundingClientRect: offsetTop non considera la
             <legend> del fieldset e metteva il badge ~30px più in basso, SOPRA il testo
             del formato. Badge sopra la pillola, staccato di 3px (non la copre). */
          b.style.top = '0px'; b.style.left = '0px';
          var br = b.getBoundingClientRect(), mr = match.getBoundingClientRect();
          b.style.top = (mr.top - br.top - br.height - 3) + 'px'; /* staccato 3px sopra la casella */
          /* centro sulla pillola, ma senza uscire a sinistra dal blocco formati (mobile) */
          var fr = fs.getBoundingClientRect();
          var cx = Math.max(mr.left + mr.width / 2, fr.left + br.width / 2);
          b.style.left = (cx - br.left - br.width / 2) + 'px';
        });
      }

      function refresh() { renderRate(); placeBadge(); }
      refresh();

      // Aggiornamenti al cambio variante + RE-RENDER del picker (Horizon rimorfa il fieldset)
      var reDeb = debounce(refresh, 60);
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.variant-picker, variant-picker, product-form-component')) reDeb();
      });
      document.addEventListener('variant:changed', reDeb);
      var vp = document.querySelector('variant-picker, .variant-picker');
      if (vp) { try { new MutationObserver(reDeb).observe(vp, { childList: true, subtree: true }); } catch (e) {} }
      var idInput = form.querySelector('[name="id"]');
      if (idInput) { try { new MutationObserver(reDeb).observe(idInput, { attributes: true, attributeFilter: ['value'] }); } catch (e) {} }
      window.addEventListener('resize', debounce(placeBadge, 120));

      /* ---- Metodi di pagamento extra (T1): Scalapay, Contrassegno, Bonifico ----
         La riga icone nativa mostra solo i gateway con icona ufficiale. I metodi
         manuali (contrassegno, bonifico) e Scalapay li aggiungo come etichette
         subito sotto le icone. La reale attivazione al checkout è lato Shopify. */
      if (!document.querySelector('.faan-pay-extra')) {
        var pAnchor = document.querySelector('.product-details .payment-icons, .product-details [class*="payment-icons"]') ||
          document.querySelector('.payment-icons, [class*="payment-icons"]');
        if (pAnchor) {
          var pex = document.createElement('div');
          pex.className = 'faan-pay-extra';
          pex.innerHTML = '<span class="faan-pay-extra__lbl">Disponibili anche:</span>' +
            ['Scalapay', 'Contrassegno', 'Bonifico bancario'].map(function (m) {
              return '<span class="faan-pay-extra__pill">' + m + '</span>';
            }).join('');
          pAnchor.insertAdjacentElement('afterend', pex);
        }
      }

      /* ---- 01/10: Breve descrizione sotto "Disponibili anche" (solo scheda prodotto) ----
         Il testo arriva gia' renderizzato nel nodo .faan-qv-desc (nascosto in PDP, visibile nella quick view). */
      if (!document.querySelector('.faan-pdp-breve')) {
        var qd = document.querySelector('.product-details .faan-qv-desc');
        var bAnchor = document.querySelector('.faan-pay-extra') || pAnchor;
        if (qd && bAnchor && !qd.closest('.quick-add-modal, dialog')) {
          var br = document.createElement('div');
          br.className = 'faan-pdp-breve rte';
          br.innerHTML = qd.innerHTML;
          bAnchor.insertAdjacentElement('afterend', br);
        }
      }

      /* ---- Riga garanzie: RIMOSSA su richiesta (24/09) ----
         Le 4 icone (Disponibile / Spedizione 24-72h / 100% naturale / Prodotto in Italia)
         non vengono più iniettate. La CSS .faan-assurance resta inerte (nessun nodo). */
    })
    .catch(function () {});
})();
